// fnError.js — get the REAL message out of a failed edge-function call.
//
// supabase-js reports every non-2xx as "Edge Function returned a non-2xx
// status code" and hides the body, which is where our functions put the
// human explanation ("Maria has no card on file…"). Staff were left with a
// riddle on every membership and payment failure. Always route errors from
// supabase.functions.invoke through this.
//
// The body can only be read once, so clone before reading; if a read fails we
// fall back to text, then to the generic message.
export async function fnErrorMessage(error, data, fallback = "Something went wrong") {
  if (data?.error) return String(data.error);
  const ctx = error?.context;
  if (ctx) {
    try {
      const src = typeof ctx.clone === "function" ? ctx.clone() : ctx;
      const body = await src.json();
      if (body?.error) return String(body.error);
      if (body?.message) return String(body.message);
    } catch (_) { /* try text next */ }
    try {
      const src = typeof ctx.clone === "function" ? ctx.clone() : ctx;
      const txt = await src.text();
      if (txt) {
        try { const j = JSON.parse(txt); if (j?.error) return String(j.error); } catch (__) { /* plain text */ }
        return txt.slice(0, 300);
      }
    } catch (_) { /* fall through */ }
  }
  return error?.message || fallback;
}
